/**
 * ShopInformationList
 * --
 */
import React, { useState, useEffect } from 'react';
import { Content, TabMenu } from 'components';
import { ShopInformationApi } from 'api';
import MessageAlert from 'utils';
import { Input, Segmented } from 'antd';

/**----------------------------------------
 * [Component] 입점업체 목록: 사이드 컴포넌트
 * ----------------------------------------
 */
const ShopInformationList = ({
  onChange,
  query,
  onLoaded,
  toggle,
  maxHeight,
  type,
  defaultChoose,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [alignValue, setAlignValue] = React.useState('SHOP'); // [SHOP, STORE]
  // 선택된 업체의 키
  const [keyword, setKeyword] = useState('');
  // 선택된 업체의 키
  const [currentShop, setCurrentShop] = useState(null);
  // 업체목록
  const [shopList, setShopList] = useState([]);

  /* ===== VARIABLE ===== */
  const shopListTemp =
    toggle === true
      ? shopList.filter((item) => item.type === alignValue)
      : type === 'SHOP'
      ? shopList.filter((item) => item.type === 'ALL' || item.type === 'SHOP')
      : type === null || type === ''
      ? shopList
      : shopList.filter((item) => item.type === type);
  const filteredData = shopListTemp?.filter(
    (item) => item.shop_information_name.indexOf(keyword) >= 0
  );
  /* ===== FUNCTION ===== */
  /**--------------------
   * 업체목록 조회
   * --------------------
   */
  const getShopInformations = async () => {
    try {
      const { status, message, data } =
        await ShopInformationApi.getShopInformations(query ?? {});
      if (status !== 200) throw { message };

      if (!query) {
        setShopList(data);
        // setShopList(
        //   data.filter((item) => item.type === 'ALL' || item.type === 'SHOP')
        // );
      } else {
        setShopList(data);
      }
      // data.filter((item) => item.type === 'ALL' || item.type === 'SHOP')
      // data.filter((item) => item.type === 'ALL' || item.is_brand === 'Y')
    } catch (e) {
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  useEffect(() => {
    getShopInformations();
  }, []);
  useEffect(() => {
    onChange(currentShop);
  }, [currentShop]);
  useEffect(() => {
    onLoaded(shopList);
    if (defaultChoose) {
      // setCurrentShop(shopList[0]?.shop_information_id);
    }
  }, [shopList]);
  useEffect(() => {
    onLoaded(filteredData);
  }, [keyword]);

  /* ===== RENDER ===== */
  return (
    <>
      <Content
        maxWidth={'100%'}
        height={'100%'}
        minHeight={490}
        padding={0}
        className="boxShadow"
        backgroundColor="#fff"
      >
        {toggle === true && (
          <div
            style={{
              padding: 10,
              borderBottom: '1px solid #EBEBEB',
            }}
          >
            <Segmented
              size="large"
              value={alignValue}
              onChange={setAlignValue}
              options={[
                {
                  label: '쇼핑몰',
                  value: 'SHOP',
                },
                {
                  label: '매장',
                  value: 'STORE',
                },
              ]}
              block
            />
          </div>
        )}
        {/* === === */}
        <Content
          maxWidth={'100%'}
          padding={10}
          style={{ borderBottom: '1px solid #EBEBEB' }}
        >
          <Input
            placeholder="업체명을 입력해주세요"
            allowClear
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </Content>

        {/* === === */}
        <Content
          maxWidth={'100%'}
          padding={5}
          className="custom-scroll"
          style={{
            height: '100%',
            ...(maxHeight && {
              maxHeight: typeof maxHeight === 'number' ? maxHeight : 800,
              overflowY: 'auto',
            }),
          }}
        >
          <TabMenu
            items={filteredData?.map((item) => ({
              ...item,
              key: item.shop_information_id,
              activeKey: item.shop_information_id,
              // title: item.shop_information_name,
              label: (
                <>
                  <p className="cursorOverOpacity">
                    {item.shop_information_name}
                    <br />
                    <span
                      style={{
                        fontWeight: '400',
                        color: '#9a9a9a',
                        fontSize: '0.9em',
                      }}
                    >
                      {item?.store_information?.business_num ?? ''}{' '}
                      {item?.store_information?.store_owner
                        ? `(${item?.store_information?.store_owner})`
                        : ''}
                    </span>
                  </p>
                </>
              ),
            }))}
            activeKey={'shop_information_id'}
            collapseKey={'shop_information_id'}
            onChange={({ key }) => setCurrentShop(key)}
          />
        </Content>
      </Content>
    </>
  );
};

ShopInformationList.defaultProps = {
  defaultId: null,
  query: null,
  maxHeight: null,
  toggle: false,
  type: 'SHOP',
  defaultChoose: false,
  onChange: () => {},
  onLoaded: () => {},
};
export default ShopInformationList;
